import Logo from "../../assets/images/new-logo.svg";
import LanguageSwitcher from "@iso/containers/LanguageSwitcher/LanguageSwitcher";

export function Navbar() {
  return (
    <nav className="shadow-[rgba(0,0,0,0.05)_0px_-1px_10px_0px]">
      <div className="mx-auto py-6 px-8 flex justify-between items-center">
        <a href="/">
          <img src={Logo} alt="GoSaffe" width={100} />
        </a>
        <LanguageSwitcher />
      </div>
    </nav>
  );
}
